// LocalStorage.js
// Class for handling Local Storage

// Imports
import lzutf8 from 'lzutf8'

// Auxiliary Constants
const storeKey = 'redux';
const versionKey = 'version';
const version = 2;

// Class Definition
class LocalStorage {
  // Compresses the given string using lzut8
  static CompressString (str) {
    return lzutf8.compress(str, { outputEncoding: "StorageBinaryString" })
  }

  // Decompresses a string compressed with CompressString method
  static DecompressString (str) {
    return lzutf8.decompress(str, { inputEncoding: "StorageBinaryString" })
  }

  // Loads Redux State from LocalStorage
  static LoadState () {
    // Checking if anything was stored
    var recordedVersion = localStorage.getItem(versionKey);
    if (recordedVersion == null)
      return {};

    // Retrieving state
    var shouldDecompress = true
    var state = localStorage.getItem(storeKey);

    // Upgrading Version if needed
    if (recordedVersion === 1) {
      var compressed = this.CompressString(state)
      recordedVersion = 2
      localStorage.setItem(versionKey, 2)
      localStorage.setItem(storeKey, compressed)
      shouldDecompress = false
    }
    
    // Checking if version was upgraded
    if (recordedVersion != version)
      return {}

    // Decompressing state string
    if (shouldDecompress)
      state = this.DecompressString(state)

    // Loading state
    return state ? JSON.parse(state) : {};
  }

  // Resets State
  static ResetState () {
    localStorage.removeItem(versionKey);
    localStorage.removeItem(storeKey);
    window.location.reload();
  }

  // Restore State from the given data
  static RestoreState (data) {
    var json = JSON.parse(data);
    if (json == null || json.state == null || json.version == null)
      return false;

    var state = JSON.stringify(json.state);
    if (state == null)
      return false;

    localStorage.setItem(storeKey, json.state);
    localStorage.setItem(versionKey, json.version);
    window.location.reload();
    return true;
  }

  // Download State
  static DownloadState () {
    var element = document.createElement("a");
    var state = {
      state: localStorage.getItem(storeKey),
      version: localStorage.getItem(versionKey),
    };

    var file = new Blob([JSON.stringify(state)], {type: 'application/json'});
    var d = new Date();
    var date = d.getFullYear() + "." + ("0"+(d.getMonth()+1)).slice(-2) + "." + ("0" + d.getDate()).slice(-2);

    element.href = URL.createObjectURL(file);
    element.download = "Carlinhos."+date+".json";
    element.click();
  }

  // Configures a Redux Store to save state to local storage
  static ConfigureStore (store) {
    store.subscribe(() => {
      localStorage.setItem(versionKey, version);
      localStorage.setItem(storeKey, this.CompressString(JSON.stringify(store.getState())));
    })
  }
}

// Default Export
export default LocalStorage;


// WEBPACK FOOTER //
// ./src/config/LocalStorage.js